import { CollapsiblePanel } from '@shared/ui-react/CollapsiblePanel';
import * as React from 'react';
import { VehicleListItem } from '@shared/vehicles/VehicleListItem';
import './VehicleList.scss';
import { IVehiclesGrouped } from '@shared/vehicles/VehiclesService';
import { VehiclesStore } from '@shared/vehicles/VehiclesStore';
import { observer } from 'mobx-react';

@observer
export class VehicleList extends React.Component<{
    vehiclesStore: VehiclesStore;
    onClick: (vehicle: IVehicle) => void;
    theme?: string; // 'desktop' | 'mobile'
}> {
    render() {
        const { vehiclesStore, onClick, theme } = this.props;
        const grouped: IVehiclesGrouped = vehiclesStore.vehiclesFilteredGroupedByStatus;

        if (this.props.vehiclesStore.isInitialLoad) {
            return <div style={{ height: 300 }} className='overlay-loading' />;
        }

        if (grouped.totalCount === 0) {
            return (
                <div className='panel-no-items'>
                    <i className='iki iki-equipment'></i>
                    <span>{vehiclesStore.vehicles.length > 0 ? __('general.n_hidden_by_filter', vehiclesStore.vehicles.length) : __('js_logpoints.no_vehicles')}</span>
                </div>
            );
        }

        return (
            <div className='vehicles-list-wrapper of-a'>
                <div className='vehicles-list vehicles-list-active'>
                    {grouped.active.map(v => (
                        <VehicleListItem vehicle={v} onClick={onClick} key={v.id} />
                    ))}
                </div>

                {!!grouped.noPosition.length && (
                    <>
                        <CollapsiblePanel defaultIsOpen={theme === 'desktop'} animated={false} label={kuura.getMessage('js_map.vehicle.without_position') + ':'}>
                            <div className='vehicles-list'>
                                {grouped.noPosition.map(v => (
                                    <VehicleListItem vehicle={v} key={v.id} />
                                ))}
                            </div>
                        </CollapsiblePanel>
                    </>
                )}

                {!!grouped.onHold.length && (
                    <>
                        <CollapsiblePanel defaultIsOpen={theme === 'desktop'} animated={false} label={kuura.getMessage('js_map.vehicle.on_hold') + ':'}>
                            <div className='vehicles-list'>
                                {grouped.onHold.map(v => (
                                    <VehicleListItem vehicle={v} key={v.id} />
                                ))}
                            </div>
                        </CollapsiblePanel>
                    </>
                )}

                {!!grouped.otherProject.length && (
                    <>
                        <CollapsiblePanel defaultIsOpen={theme === 'desktop'} animated={false} label={kuura.getMessage('js_map.vehicle.moved_to_other_project') + ':'}>
                            <div className='vehicles-list'>
                                {grouped.otherProject.map(v => (
                                    <VehicleListItem vehicle={v} key={v.id} />
                                ))}
                            </div>
                        </CollapsiblePanel>
                    </>
                )}
            </div>
        );
    }
}
